module.exports = __webpack_public_path__ + "img/package-crown.0209ad6b.svg";